import React, { useEffect, useState } from 'react';
import axios from 'axios';
//import moment from "moment";
import Swal from "sweetalert2";
import "react-simple-keyboard/build/css/index.css";
import { useSelector, connect, useDispatch } from "react-redux";

import "./Gate.css"
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
//import { setActionOptionsFor } from 'sweetalert/typings/modules/state';
import * as Actions from "./incidentcallstats/incidentcallstats.actions"

function Gate(props) {
  const dispatch = useDispatch();
  const incidentcallstate = useSelector((state) => state.callstatsReducer.incidentcallstats);
  const [value, setValue] = useState("");
  const [pinTime, setPinTime] = useState(new Date());

  function tick() {
    setPinTime(new Date());
  }

  useEffect(() => {
    if (incidentcallstate.unitcode === undefined || incidentcallstate.unitcode === ""){
      const serializedState = localStorage.getItem('unit_code');
      if (serializedState !== null && serializedState !== "") {
        dispatch(Actions.setUnitCode(serializedState));
      } else {
        console.log("No Unitcode found");
      }
    }
  }, [dispatch, incidentcallstate.unitcode])

  useEffect(() => {
    if (value === null || value === "" || value.length < 4) {
      return;
    }
    const Toast = Swal.mixin({
      toast: true,
      timer: 5000,
      timerProgressBar: true,
    })
    Toast.fire({
      icon: "info",
      title: "Please Wait"
    });
    
    const postpayload = {
      pincode: value,
      unit: incidentcallstate.unitcode.toUpperCase()
    };
    axios.post('/api/Gate/validate', postpayload)
      .then(res => {
        setValue("");
        if (!res.data.success){
          
          Toast.fire({
            icon: "error",
            title: "Invalid PIN!",
            text: "Pin you enter didn't match. Try again"
          });
        } else {
          Toast.fire({
            icon: "success",
            title: "Success",
            text: "Please wait while we open the gate"
          });
          //setTimeout(() => {
          //  window.location.reload();
          //}, 5000);
        }
      })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        setValue("");
        //setTimeout(() => {
        //  window.location.reload();
        //}, 5000);
        Toast.fire({
            icon: "error",
            title: "System Error",
            text: "An error occured. Please try again. Reloading"
          });
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
    });
  }, [value, incidentcallstate.unitcode]);

  function onPINchange(event){
    if (event !== undefined){
      let fieldVal = event.target.value;
      setValue(fieldVal);
      console.log(fieldVal);
    }
  }

  useEffect(() => {
    const timerID = setInterval(() => {
      tick()
    }, 1000);

    return () => clearInterval(timerID);
  }, []);

  return (
    <Row>
      <Col className="Pin home-container">
        <div className="text text-center">
          <h1>{incidentcallstate.unitcode.toUpperCase()} Gate</h1>
          <h2 id="todaysDate">{pinTime.toLocaleTimeString()}</h2>
        </div>
        <Form.Control size="lg" type="number" id="test-numinput" value={value} placeholder='Enter PIN here' autoFocus onChange={(event) => onPINchange(event)} /> 

      </Col>
    </Row>
  );
}

export default connect()(Gate);